import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Info as InfoIcon } from 'react-feather'
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import clsx from 'clsx'

import useDaiOptOut from 'hooks/useDaiOptOut'

import theme from 'theme'
import useStyles from './styles'
import constants from 'constants/index'

import { ReactComponent as DaiStarIcon } from 'images/dai-star.svg'

const DaiControlHeader = () => {
  const { OWNED_BY, STATUSES } = constants.dai.solutions

  const classes = useStyles()
  const { daiOptOuts, isLoadingStart: isDaiOptOutLoading } = useDaiOptOut()
  const { control, errors, watch } = useFormContext()

  const globalValue = watch('global')
  const isGlobalEnabled = globalValue !== STATUSES.DISABLED

  const globalData = daiOptOuts?.global
  const isLockedByCollaborator = globalData?.ownedBy === OWNED_BY.COLLABORATOR
  const isLockedByOrganization = globalData?.ownedBy === OWNED_BY.ORGANIZATION
  const isGlobalLocked =
    (isLockedByCollaborator || isLockedByOrganization) &&
    globalData?.status === STATUSES.DISABLED

  const handleStatusChange = (checked) =>
    checked ? STATUSES.ENABLED : STATUSES.DISABLED

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={2}
      gridGap={theme.spacing(1)}
    >
      <Box>
        <Box display="flex" gridGap={theme.spacing(1)}>
          <Typography variant="h5">Configurações de IA</Typography>
          <DaiStarIcon
            width={14}
            height={14}
            color={theme.palette.dai.shinyBlue}
          />
          <Box alignContent="center">
            <Tooltip title="Habilita ou desabilita todas as funcionalidades de inteligência artificial da plataforma. Caso a opção seja desabilitada, as novas ferramentas de IA lançadas posteriormente serão desabilitadas por padrão.">
              <Box>
                <InfoIcon className={classes.infoIcon} size={14} />
              </Box>
            </Tooltip>
          </Box>
        </Box>
        <Typography variant="body2">
          Defina quais ferramentas de IA estarão habilitadas para a sua
          organização.
        </Typography>
      </Box>
      <Box display="flex" justifyContent="end" alignItems="center">
        {isDaiOptOutLoading ? (
          <Skeleton width={123} height={20} variant="rect" />
        ) : (
          <Controller
            as={
              <FormControl fullWidth>
                <FormControlLabel
                  label={
                    <Typography variant="h6" className={classes.label}>
                      {isGlobalEnabled ? 'Ativado' : 'Desativado'}
                    </Typography>
                  }
                  labelPlacement="start"
                  classes={{
                    root: clsx(classes.formControlLabel, {
                      [classes.disabledLabel]: isGlobalLocked,
                    }),
                  }}
                  control={
                    <Tooltip
                      title={
                        isGlobalLocked
                          ? 'Esta funcionalidade não está disponível. Entre em contato com o administrador para mais informações.'
                          : ''
                      }
                    >
                      <Box
                        className={clsx({
                          [classes.locked]: isGlobalLocked,
                        })}
                      >
                        <Switch
                          checked={isGlobalEnabled}
                          color="primary"
                          disabled={isGlobalLocked}
                        />
                      </Box>
                    </Tooltip>
                  }
                />
                {!!errors?.global && (
                  <FormHelperText error>
                    {errors?.global?.message}
                  </FormHelperText>
                )}
              </FormControl>
            }
            control={control}
            name="global"
            onChange={([event]) => handleStatusChange(event.target.checked)}
          />
        )}
      </Box>
    </Box>
  )
}

export default DaiControlHeader
